import type { ToastState } from './types'
import type { Selector } from 'store'

import { NAME } from './constants'

export const selectToast: Selector<ToastState> = (state) => state[NAME]
